/**
 * Inline SVG icons used across the Edit Product redesign. Each icon is a
 * 16×16 thin-stroke glyph tuned for the amber-tinted section header tile.
 */
const baseProps = {
  width: 14,
  height: 14,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
};

export function CameraIcon() {
  return (
    <svg {...baseProps}>
      <path d="M3 7h3l2-3h8l2 3h3v13H3z" />
      <circle cx="12" cy="13" r="4" />
    </svg>
  );
}

export function InfoIcon() {
  return (
    <svg {...baseProps}>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 16v-4M12 8h.01" />
    </svg>
  );
}

export function TagIcon() {
  return (
    <svg {...baseProps}>
      <path d="M20.6 13.4l-7.1 7.1a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z" />
      <circle cx="7.5" cy="7.5" r="1.2" fill="currentColor" />
    </svg>
  );
}

export function BoxIcon() {
  return (
    <svg {...baseProps}>
      <path d="M21 8v13H3V8" />
      <path d="M1 3h22v5H1z" />
      <path d="M10 12h4" />
    </svg>
  );
}

export function TruckIcon() {
  return (
    <svg {...baseProps}>
      <path d="M1 3h15v13H1z" />
      <path d="M16 8h4l3 3v5h-7" />
      <circle cx="5.5" cy="18.5" r="2" />
      <circle cx="18.5" cy="18.5" r="2" />
    </svg>
  );
}

export function GlobeIcon() {
  return (
    <svg {...baseProps}>
      <circle cx="12" cy="12" r="10" />
      <path d="M2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20" />
    </svg>
  );
}

export function SparkleIcon() {
  return (
    <svg {...baseProps}>
      <path d="M12 2l1.8 5.5L19 9l-5.2 1.5L12 16l-1.8-5.5L5 9l5.2-1.5L12 2z" />
    </svg>
  );
}

export function ChartIcon() {
  return (
    <svg {...baseProps}>
      <path d="M3 3v18h18" />
      <path d="M7 14l3-3 4 4 6-7" />
    </svg>
  );
}
